import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';

import { withRouter, Redirect } from 'react-router-dom';

import { SortDirection } from 'react-virtualized';
import { CircularProgress, ListItem, MenuButton } from 'react-md';
import { isEqual, isEmpty, get } from 'lodash-es';

import { CoogTable } from '@coog/react-components';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { theme } from '../../Theme/theme';
import { stringifyQuery, parseQuery } from '../../Utils/Utils';
import * as salesRoutesActions from '../../Services/SalesRoutes/actions';
import FilterControls from '../../Components/Filter/FilterControls';

import { applyFilters } from './filters';

import { columns, filtersUI } from './config';

import './SalesRoutes.scss';

class SalesRoutes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
      redirectTo: undefined,
      list: undefined,
      filteredList: undefined,
      filters: props.filters,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static getDerivedStateFromProps(nextProps, prevState) {
    const { list: nextList } = nextProps;
    const { list: prevList } = prevState;
    let newState = null;

    if (nextList && !!nextList.toJS && !Immutable.is(prevList, nextList)) {
      newState = {
        list: nextList, // TODO add filtering statement...
      };
    }

    return newState;
  }

  componentDidMount() {
    const self = this;
    const { actions, system, list, location, history, filters: defaultFilters } = self.props;
    actions.fetchSalesRoutes({ date: new Date(), dateFormat: system.dateFormat });
    const filters = isEmpty(parseQuery(location.search)) ? defaultFilters : parseQuery(location.search);
    self.setState({ filters });
    history.push({
      pathname: location.pathname,
      search: stringifyQuery(filters),
    });
    if (list) {
      self.filter({ list, ref: 'componentDidMount', filters });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const self = this;
    const { filters: prevFilters } = prevState;
    const { list, location } = self.props;
    //
    if (!Immutable.is(prevProps.list, list)) {
      if (typeof list !== 'undefined' && !Immutable.is(prevState.list !== list)) {
        self.filter({ list, ref: 'componentDidUpdate1' });
      }
    }
    // Filters
    const filters = prevFilters || parseQuery(location.search);
    if (typeof list !== 'undefined' && filters && !isEqual(prevFilters, filters)) {
      self.setState({ filters });
      self.filter({ list, ref: 'componentDidUpdate2' });
    }
  }

  handleFiltersChange = filters => {
    const { list, history, location } = this.props;
    history.push({
      pathname: location.pathname,
      search: stringifyQuery(filters),
    });
    this.setState({ filters });
    this.filter({ list, ref: 'handleFiltersChange', filters });
  };

  filter = ({ list, /* ref, */ filters: newFilters }) => {
    const { filters } = this.state;
    const filteredList = applyFilters({ list, filters: newFilters || filters });
    // eslint-disable-next-line react/no-did-update-set-state
    this.setState({ filteredList });
  };

  handleActionClick = ({ action, questionnaire }) => {
    // eslint-disable-next-line react/prop-types
    const { actions } = this.props;
    const payload = {
      salesRoute: {
        questionnaire: {
          id: questionnaire.id,
          code: questionnaire.code,
        },
      },
    };

    switch (action) {
      case 'create':
        // eslint-disable-next-line react/prop-types
        actions.createSalesRoute({ payload });
        break;
      default:
        break;
    }
  };

  render() {
    const { redirect, redirectTo, ...state } = this.state;
    if (redirect) return <Redirect push to={redirectTo} />;

    const { list, filteredList, filters } = state;
    const { pageTitle, canonical, system, strings, redirectSR, questionnaires } = this.props;
    const to = {
      pathname: `/salesroutes/${redirectSR}`,
      state: { from: this.location },
    };

    if (redirectSR) {
      return <Redirect push to={to} preserveQueryString={false} />;
    }

    const helmet = (
      <Helmet
        htmlAttributes={{
          class: 'coog',
          lang: system.i18n.lang,
        }}
      >
        <meta charSet="utf-8" />
        <title>{get(strings, pageTitle, 'SalesRoute')}</title>
        <meta name="description" content={get(strings, pageTitle, 'SalesRoute')} />
        <link rel="canonical" href={canonical} />
      </Helmet>
    );

    const salesRoute = () =>
      list && filteredList ? (
        <MuiThemeProvider theme={theme}>
          <CoogTable
            defaultSorted={{ sortBy: 'updatedAt', sortDirection: SortDirection.DESC }}
            rows={filteredList}
            columns={columns(this.handleAction, strings, system.i18n)}
            strings={strings}
            uid="id"
            onClickCellAction={this.handleAction}
          />
        </MuiThemeProvider>
      ) : (
        <CircularProgress id="salesRoutes-loading" className="loading" />
      );

    return (
      <div className="coog-app salesRoutes">
        {helmet}
        <div className="blocks-header">
          <h1 className="md-title md-cell md-cell--12">{get(strings, pageTitle, '')}</h1>
          <div className="blocks-actions">
            {questionnaires && questionnaires.size ? (
              <MenuButton
                id="add-quotation"
                floating
                secondary
                menuItems={questionnaires.toJS().map(q => (
                  <ListItem
                    key={`${q.id}`}
                    primaryText={q.title}
                    onClick={() => this.handleActionClick({ action: 'create', questionnaire: q })}
                  />
                ))}
                anchor={{ x: MenuButton.HorizontalAnchors.CENTER, y: MenuButton.VerticalAnchors.TOP }}
                simplifiedMenu={false}
                repositionOnScroll={false}
                tooltipLabel={strings['quotations.actions.newquotation.btn.label'] || 'Ajouter un parcours de vente'}
                tooltipPosition="left"
              >
                add
              </MenuButton>
            ) : (
              <></>
            )}
          </div>
        </div>
        {/* <Divider /> */}
        <div className="block-controls">
          {filteredList ? (
            <div className="block-info">
              <span className="value">{filteredList.size}</span>
              <span className="label">{get(strings, 'salesroute.controls.info.label', 'Sales Route(s) find')}</span>
            </div>
          ) : undefined}
          <FilterControls
            id="salesRoutes-filters-block"
            key="salesRoutes-filters-block"
            strings={strings}
            filters={filters}
            onFiltersChange={this.handleFiltersChange}
            filtersUI={filtersUI({ strings, questionnaires })}
          />
        </div>
        <div className="md-body md-cell md-cell--12">{salesRoute()}</div>
      </div>
    );
  }
}

SalesRoutes.propTypes = {
  pageTitle: PropTypes.string,
  canonical: PropTypes.string,
  // eslint-disable-next-line
  list: PropTypes.instanceOf(Immutable.List),
  // eslint-disable-next-line
  location: PropTypes.object.isRequired,
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  strings: PropTypes.objectOf(PropTypes.string),
  // eslint-disable-next-line
  system: PropTypes.object,
  // eslint-disable-next-line
  filters: PropTypes.object,
  redirectSR: PropTypes.string,
};
SalesRoutes.defaultProps = {
  pageTitle: 'title.salesroute.list',
  canonical: 'http://www.coopengo.com/',
  strings: {},
  list: undefined,
  filters: {
    query: '',
    queryName: '',
    status: [],
    commercialSalesRouteId: [],
  },
  redirectSR: null,
  questionnaires: [],
};

const getStrings = strings => (strings && strings.toJS ? strings.toJS() : strings || {});

const mapStateToProps = state => ({
  list: state.getIn(['salesroutes', 'list']),
  strings: getStrings(state.getIn(['salesroutes', 'strings'])),
  system: state.toJS().system,
  redirectSR: state.getIn(['salesroutes', 'current']),
  questionnaires: state.getIn(['salesroutes', 'questionnaires']),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...salesRoutesActions }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SalesRoutes));
